import { IDynamicSubmitFieldProps } from "@view/common/DynamicForm/DynamicFormContracts";
import styles from "./LoginSubmitFieldWithBack.module.css";
import Button from "@view/common/Components/Button";

export interface ILoginSubmitFieldWithBackProps extends IDynamicSubmitFieldProps {
  onResendClick: () => void;
  loadingResend?: boolean;
}

const LoginSubmitFieldWithResend = (props: ILoginSubmitFieldWithBackProps) => {
  
  return (
    <div className={styles.root}>
      <Button
        variant="secondary"
        type="button"
        disabled={props.loadingResend || props.loading}
        onClick={props.onResendClick}
        loading={props.loadingResend ?? false}
        className={styles.submitButton}
      >
        Reenviar
      </Button>
      <Button
        variant="secondary"
        type="button"
        disabled={props.disabled}
        onClick={props.onSubmit}
        loading={props.loading ?? false}
        className={styles.submitButton}
      >
        {props.label}
      </Button>
    </div>
  );
};

export default LoginSubmitFieldWithResend;
